import { ExtendedAddress } from '@porterin/booking-flow/src/order-review/domain/entities/ExtendedAddress';
import { LatLng } from '@porterin/booking-flow/src/order-review/domain/entities/LatLng';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import {
  selectLocationIcon,
  zoomInIconUrl,
  zoomInIconAlt,
  zoomOutIconUrl,
  zoomOutIconAlt,
} from '@porterin/component-library/src/location-accuracy/store/LocationAccuracyStore';
import { handleGetLocation } from '@porterin/component-library/src/location-accuracy/utils/LocationAccuracyHelpers';
import Image from 'next/image';
import React from 'react';
import Button from '@porterin/component-library/src/base-components/button/Button';
import { getScreenName } from '@porterin/lead-flow/src/components/FareEstimateHelper';

export interface MapAutoDetectLocationProps {
  is_dragging: boolean;
  set_center: (value: React.SetStateAction<LatLng>) => void;
  handleZoomIn?: () => void;
  handleZoomOut?: () => void;
}

export const MapAutoDetectLocationCmpDesktop: React.FC<
  MapAutoDetectLocationProps
> = ({ is_dragging, set_center, handleZoomIn, handleZoomOut }) => {
  const { selectLocation, state } = useLocation();

  const handleGetLocationClick = () => {
    handleGetLocation({
      selectLocation: (result: ExtendedAddress) => {
        selectLocation(result);
        set_center({
          lat: result.location.lat,
          lng: result.location.lng,
        });
      },
      waypoint: state?.waypoint,
      screen_name: getScreenName(),
    });
  };

  if (is_dragging) {
    return null;
  }

  return (
    <div className="absolute right-[1rem] bottom-[7.2rem] z-10 flex flex-col gap-3 select-none">
      <div className="flex flex-col bg-[#FCFDFD] rounded-[0.8rem] shadow-md overflow-hidden p-[0.8rem]">
        <Button
          identifiers={{ id: 'zoom-in-btn' }}
          interactions={{ onClick: handleZoomIn }}
          data-testid="zoom-in-btn"
          className="px-0 py-0 border-b border-gray-200 flex items-center justify-center pb-[0.8rem] rounded-none shadow-none bg-transparent"
          aria-label="Zoom In"
        >
          <Image
            src={zoomInIconUrl}
            alt={zoomInIconAlt}
            width={14}
            height={14}
          />
        </Button>
        <Button
          identifiers={{ id: 'zoom-out-btn' }}
          interactions={{ onClick: handleZoomOut }}
          data-testid="zoom-out-btn"
          className="px-0 py-0 pt-[0.8rem] flex items-center justify-center rounded-none shadow-none bg-transparent"
          aria-label="Zoom Out"
        >
          <Image
            src={zoomOutIconUrl}
            alt={zoomOutIconAlt}
            width={14}
            height={14}
          />
        </Button>
      </div>
      <Button
        identifiers={{ id: 'get-location-btn' }}
        interactions={{ onClick: handleGetLocationClick }}
        data-testid="get-location-btn"
        className="px-0 py-0 flex items-center justify-center bg-white rounded-full p-2 shadow-lg"
        aria-label="Get Current Location"
      >
        <Image
          src={selectLocationIcon}
          alt="Select Location"
          width={20}
          height={20}
        />
      </Button>
    </div>
  );
};
